/**
 * Number Transcript search results
 */

import { h } from "preact";
import { Match } from "../helpers/findSearchMatches";

type ResultsProps = {
  searchResults: Match[];
  searchString: string | undefined;
  enabled: boolean;
};

const Results = ({ searchResults, searchString, enabled }: ResultsProps) => {
  const commonProps = {
    class: enabled ? "Results" : "Results Results-isHidden",
  };

  if (!searchString) {
    return null;
  }

  if (searchString.length > 0 && searchResults.length > 0) {
    return (
      <div {...commonProps} data-testid="results">
        {searchResults.length}{" "}
        {searchResults.length === 1 ? "result" : "results"}
      </div>
    );
  } else {
    return (
      <div {...commonProps} data-testid="no-results">
        No search results found matching "{searchString}".
      </div>
    );
  }
};

export default Results;
